import script from "./PriceingDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceingDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./PriceingDrawer.vue?vue&type=style&index=0&id=ac4eab62&lang=scss"

const __exports__ = script;

export default __exports__